<div class="auth-box__content auth-box__content--header">
  <a class="auth-box__icon icon-edutin w-fit" [href]="environment.domain"></a>

  @if (isBusiness) {
    <div class="auth-header__business">
      <span class="auth-box__title">{{ 'authHeader.business.title' | translate }}</span>
      <p class="auth-box__description">{{ 'authHeader.business.subtitle' | translate }}</p>

      <ul class="auth-header__features">
        <li>
          <span class="icon-tick"></span>
          <span [innerHTML]="'authHeader.business.feature1' | translate"></span>
        </li>
        <li>
          <span class="icon-tick"></span>
          <span [innerHTML]="'authHeader.business.feature2' | translate"></span>
        </li>
      </ul>

      <p class="auth-header__trust">{{ 'authHeader.business.trust' | translate }}</p>

      <div class="auth-header__companies">
        @for (n of companyLogos; track n) {
          <img
            [src]="'assets/images/companies/company-' + n + '.png'"
            [alt]="'authHeader.business.companyAlt' | translate: { n: n }"
          />
        }
      </div>
    </div>
  } @else {
    @if (textData(); as data) {
      <div>
        <span class="auth-box__title">{{ data.title }}</span>
        <p class="auth-box__description" [innerHTML]="data.text"></p>
      </div>
    }
  }
</div>
